import first from "lodash/first";
import pym from "pym.js";
import type { Pym } from "pym.js";
import type { FunctionComponent } from "react";
import { useEffect, useState } from "react";
import { graphql, useFragment } from "react-relay";

import type { contentNewsletterArticleArticle$key } from "~/queries/__generated__/contentNewsletterArticleArticle.graphql";

import { Container, IframeWrapper, StyledPlaceholder } from "./styles";

type Props = {
  className?: string;
  onIframeLoaded: () => void;
  reference: contentNewsletterArticleArticle$key;
};

export const NewsletterArticleContent: FunctionComponent<Props> = ({
  className,
  onIframeLoaded,
  reference,
}) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  const content = useFragment(
    graphql`
      fragment contentNewsletterArticleArticle on Article {
        entityId
        relatedLinks
      }
    `,
    reference,
  );

  const iframeSource = first(content?.relatedLinks);
  const iframeId = content.entityId ? `nl-article-iframe-${content.entityId}` : undefined;

  useEffect(() => {
    if (!iframeId || !iframeSource || isLoaded) return;
    const pymJs = pym as Pym;
    // cspell: ignore trackscroll
    pymJs.Parent(iframeId, iframeSource, { trackscroll: true });
    setIsLoaded(true);
    onIframeLoaded();
  }, [onIframeLoaded, isLoaded, iframeSource, iframeId]);

  return (
    <Container className={className}>
      <IframeWrapper id={iframeId} />
      <StyledPlaceholder />
    </Container>
  );
};

NewsletterArticleContent.displayName = "NewsletterArticleContent";
